/* The full cart is the next step after a successful product add in page-with-drawer mode. */
let navigating = false;
const productAddSources = new Set(['product-form-component', 'mb-apple-compare']);

window.addEventListener('pageshow', () => { navigating = false; });

document.addEventListener('cart:update', (event) => {
  const detail = event.detail?.data;
  if (navigating || !detail || detail.didError || !productAddSources.has(detail.source)) return;
  const cartURL = new URL(Theme.routes.cart_url, window.location.origin);
  if (window.location.pathname.replace(/\/$/, '') === cartURL.pathname.replace(/\/$/, '')) return;
  // Keep a supplied Shopify preview ID while reviewing an unpublished copy.
  const previewID = new URL(window.location.href).searchParams.get('preview_theme_id');
  if (previewID) cartURL.searchParams.set('preview_theme_id', previewID);
  navigating = true;
  window.location.assign(cartURL.href);
});
